'use strict';

angular.module('amexReconciliationApp')
  .factory('PaginationModelFactory', function PaginationModelFactory(ModelFactory) {
    return {
      create: function (pageSize) {
        return new PaginationModel(pageSize);
      }
    };

    function PaginationModel(pageSize) {
      var pageModel = ModelFactory.create('PaginationModel', [
        'pageNumber',
        'pageSize',
        'records',
        'recordsOnCurrentPage'
      ]);
      pageModel.pageSize(pageSize);
      pageModel.pageNumber(0);
      pageModel.records([]);
      pageModel.recordsOnCurrentPage([]);

      var self = this;

      self.records = pageModel.records;
      self.pageSize = pageModel.pageSize;
      self.onRecordsOnCurrentPageChanged = pageModel.onRecordsOnCurrentPageChanged;
      self.onPageSizeChanged = pageModel.onPageSizeChanged;
      self.recordsOnCurrentPage = pageModel.recordsOnCurrentPage;
      self.pageNumber = pageModel.pageNumber;

      self.goToPageNumber = function (pageNumber) {
        if (self.getLastPage() < pageNumber) {
          pageNumber = self.getLastPage();
        }
        pageModel.pageNumber(pageNumber);
        self.updateCurrentPage();
      };

      self.totalCount = function () {
        return pageModel.records().length;
      };

      self.pageStart = function () {
        if (self.totalCount() > 0) {
          return (pageModel.pageNumber() - 1) * pageModel.pageSize() + 1;
        }
        return 0;
      };

      self.pageEnd = function () {
        if (self.totalCount() > 0) {
          return Math.min(
            self.totalCount(),
            (pageModel.pageNumber() * pageModel.pageSize())
          );
        }
        return 0;
      };

      self.showPagination = function() {
        return self.totalCount() > pageModel.pageSize();
      };

      self.updateCurrentPage = function () {
        pageModel.recordsOnCurrentPage(_.slice(
          pageModel.records(),
          self.pageStart() - 1,
          self.pageEnd()
        ));
      };

      self.repaginate = function(records) {
        if (_.isEmpty(records)) {
          pageModel.pageNumber(0);
        } else {
          pageModel.pageNumber(1);
        }

        pageModel.records(records);
        self.updateCurrentPage();
      };

      function hasNextPage() {
        return self.pageEnd() < self.totalCount();
      }

      function hasPreviousPage() {
        return pageModel.pageNumber() > 1;
      }

      self.nextPage = function () {
        if (hasNextPage()) {
          pageModel.pageNumber(pageModel.pageNumber() + 1);
          self.updateCurrentPage();
        }
      };

      self.previousPage = function () {
        if (hasPreviousPage()) {
          pageModel.pageNumber(pageModel.pageNumber() - 1);
          self.updateCurrentPage();
        }
      };

      self.goToLastPage = function () {
        if(!self.isLastPage()) {
          self.goToPageNumber(self.getLastPage());
        } else {
          self.updateCurrentPage();
        }
      };

      self.isLastPage = function () {
        return !hasNextPage();
      };

      self.getLastPage = function () {
        return Math.ceil(self.totalCount() / pageModel.pageSize());
      };

    }
  });


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/factories/PaginationModelFactory.js
// module id = 549
// module chunks = 0